import { AxiosInstance } from "axios";
import { getBoardApiUrl } from "helpers";
import { OneDriveSyncResult } from "models/OneDriveSyncResult";
import { OneDriveViewModel } from "models/OneDriveViewModel";
import { SyncActionsType } from "models/SyncActionsType";

export class OneDriveApi {
  constructor(private axios: AxiosInstance) {}

  async getByMeeting(meetingId: number, signal?: AbortSignal) {
    const url = getBoardApiUrl(`oneDrive/meeting/${meetingId}`);
    const response = await this.axios.get<OneDriveViewModel>(url, { signal });
    return response.data;
  }

  async synchronize(meetingId: number, documentActions: SyncActionsType) {
    const url = getBoardApiUrl(`oneDrive/meeting/${meetingId}/synchronize`);

    const patch = Object.entries(documentActions)
      .map(([key, value]) => ({ id: Number(key), action: value }))
      .filter((x) => x.action !== "None");

    const response = await this.axios.post<OneDriveSyncResult>(url, patch);
    return response.data;
  }
}
